'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import { LoadingIndicator } from './LoadingIndicator';
import { WebAPIChartSlicerData } from '../../globals/webApiTypes/elements/WebAPICBS';
import { CBSStatlineDataset } from './cbsStatline.types';
const CbsGraphClientComponent = dynamic(() => import('./CbsGraph.client'), {
  loading: () => <LoadingIndicator />,
  ssr: false
});
export function CbsGraphClientLoader(t0) {
  const $ = _c(3);
  const {
    chartSlicerData,
    graphDataPromise
  } = t0;
  let t1;
  if ($[0] !== chartSlicerData || $[1] !== graphDataPromise) {
    t1 = <CbsGraphClientComponent chartSlicerData={chartSlicerData} graphDataPromise={graphDataPromise} />;
    $[0] = chartSlicerData;
    $[1] = graphDataPromise;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}